import { useEffect } from "react";
import Layout from "./components/layout/Layout";
import CredentialView from "./views/CredentialView";
import ProofGenerationView from "./views/ProofGenerationView";
import ProofCompletionView from "./views/ProofCompletionView";
import { useAuthStore } from "./store/authStore";
import StartView from "./views/StartView";

import { Screen } from "./types/enums";
import PendingView from "./views/PendingView";
import "./plutoSdk";
import client from "./websocket/client";
import OauthView from "./views/OauthView";
import ErrorView from "./views/ErrorView";
import TimeoutView from "./views/TimeoutView";
import UserNetworkView from "./views/UserNetworkView";
import { useDemoStore } from "./store/demoStore";
function App() {
  const darkMode = useAuthStore((state) => state.darkMode);
  const screen = useAuthStore((state) => state.screen);
  const hasStarted = useAuthStore((state) => state.hasStarted);
  const initialized = useDemoStore((state) => state.initialized);

  /**
   * Block Password managers since
   * they won't work with our widget
   */
  useEffect(() => {
    // Set up once, clean up on unmount
    const observer = new MutationObserver((mutations) => {
      const elements = [
        `[style*="z-index: 2147483647"]`,
        `div[data-lastpass-root]`,
        `div.icloud-password-field`,
        `div.__1password`,
        `div.__lp-inline-edit-element`,
      ];

      elements.forEach((selector) => {
        const element = document.querySelector(selector);
        if (element) {
          element.remove();
        }
      });
    });

    // Start observing with a configuration
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });

    // Clean up
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (initialized) {
      client.init();
    }
  }, [initialized]);

  useEffect(() => {
    // Add or remove the .dark class on the <html> element
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  const renderView = () => {
    if (!hasStarted && screen !== Screen.TIMEOUT) {
      return <StartView />;
    }

    // Otherwise, render the screen according to the screen state
    switch (screen) {
      case Screen.INFORMATION:
        return <PendingView />;
      case Screen.SOURCE_SELECTION:
        return <PendingView />;
      case Screen.DATA_SELECTION:
        return <PendingView />;
      case Screen.CREDENTIALS:
        return <CredentialView />;
      case Screen.PROOF_GENERATION:
        return <ProofGenerationView />;
      case Screen.PROOF_COMPLETION:
        return <ProofCompletionView />;
      case Screen.PENDING:
        return <PendingView />;
      case Screen.OAUTH:
        return <OauthView />;
      case Screen.ERROR:
        return <ErrorView />;
      case Screen.TIMEOUT:
        return <TimeoutView />;
      case Screen.USER_NETWORK:
        return <UserNetworkView />;
      default:
        return <PendingView />;
    }
  };

  return <Layout>{renderView()}</Layout>;
}

export default App;
